export const byLatestSave = (a, b) => {
  const latestSaveA = a.history[a.history.length - 1]?.time;
  const latestSaveB = b.history[b.history.length - 1]?.time;
  if (latestSaveA > latestSaveB) {
    return -1;
  } else {
    return 1;
  }
};
